import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { useAtomValue } from 'jotai';
import { ROUTES } from './constants/RouteNameMapping';
import { GenericFallbacksWrapper } from './components/Fallback/GenericFallbacksWrapper';
import { useFdSearchParams } from './hooks/useFdSearchParams';
import { useTitle } from './hooks/useTitle';
import { NavWrapper } from './NavWrapper';
import { PersonaKey } from './services/PermissionAndRolesKeys';
import { PermissionService } from './services/PermissionService';
import { authenticatedUserState } from './services/state/AuthState';
import { useBulkUploadStatusSubscription } from './pages/AdminPanel/CustomFields/hooks/useBulkUploadStatus';
import { hideBootLoader } from './util/bootLoader';
import { useDocumentsDetectedSubscription } from './pages/DocumentHub/hooks/useDocumentsDetected';

export function RouteWrapper() {
  const user = useAtomValue(authenticatedUserState);
  const location = useLocation();
  const title = useTitle();
  const { noNavWrapper } = useFdSearchParams();
  const externalUser = PermissionService.get().hasPersona(PersonaKey.respondent);
  useBulkUploadStatusSubscription();
  useDocumentsDetectedSubscription();

  useEffect(() => {
    document.title = `Foresight | ${title}`;
  }, [title]);

  // The first screen with content, so the page-level loader from index.html ends here.
  useEffect(() => {
    if (user !== undefined) {
      hideBootLoader();
    }
  }, [user]);

  const isPageWithoutNav =
    location.pathname.match(new RegExp(`/${ROUTES.KPI_REQUESTS_RESPONSES_HOME}/\\d+`)) ||
    location.pathname.match(new RegExp(`/${ROUTES.KPI_PENDING_REQUESTS_BASE}/\\d+`)) ||
    location.pathname.match(new RegExp(`/${ROUTES.CHATBOT}`)) ||
    location.pathname.match(new RegExp(`/${ROUTES.KPI_THANK_YOU_SCREEN}`));
  const isLoginSuccessPage = location.pathname.match(ROUTES.EXCEL_LOGIN);

  if (user === undefined) {
    return null;
  }

  return (
    <>
      {isPageWithoutNav || externalUser || isLoginSuccessPage || noNavWrapper ? (
        <GenericFallbacksWrapper>
          <Outlet />
        </GenericFallbacksWrapper>
      ) : (
        <NavWrapper />
      )}
    </>
  );
}
